import { EXTERNAL } from 'apps/auth/constants/Constants';
import { DELIVERY_METHOD, PAYMENT_METHOD, SOURCE, SOURCE_CODE_FROM } from 'apps/auth/constants/fieldsName';
import { getExtra } from 'apps/auth/helpers/utils';

export const UPDATE_FORM_PROPERTY = 'UPDATE_FORM_PROPERTY';
export const CHANGE_FIELD = 'CHANGE_FIELD';
export const CHANGE_FIELD_VALUE = 'CHANGE_FIELD_VALUE';
export const SET_NEW_FORM = 'SET_NEW_FORM';
export const UPDATE_FIELDS = 'UPDATE_FIELDS';
export const UPDATE_FIELD_VALUES = 'UPDATE_FIELD_VALUES';
export const ADD_NEW_FIELDS = 'ADD_NEW_FIELDS';
export const REMOVE_FIELD = 'REMOVE_FIELD';
export const SET_FIELD_ERROR = 'SET_FIELD_ERROR';
export const REMOVE_FIELD_ERROR = 'REMOVE_FIELD_ERROR';
export const SET_NEW_FIELDS = 'SET_NEW_FIELDS';
export const REPLACE_FORM_FIELDS = 'REPLACE_FORM_FIELDS';
export const SCROLL_TO_FIELD = 'SCROLL_TO_FIELD';
export const SET_FIELD_VISIBLE = 'SET_FIELD_VISIBLE';
export const CHANGE_FIELD_PROPERTY = 'CHANGE_FIELD_PROPERTY';
export const DELETE_FORM = 'DELETE_FORM';

const getClearFieldName = (fieldName) => {
    if (fieldName?.indexOf('toValues[') === -1) {
        return fieldName;
    } else {
        const m = fieldName?.match('toValues\\[(.*)\\]');
        return m && m[1] ? m[1] : fieldName;
    }
};

export const setFieldVisible = (formName, fieldName, visible = true) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: SET_FIELD_VISIBLE,
                formName: formName,
                fieldName: fieldName,
                visible: visible,
            }),
        );
    };
};

export const scrollToField = (formName, fieldName) => {
    return (dispatch) => {
        dispatch({
            type: SCROLL_TO_FIELD,
            formName: formName,
            fieldName: fieldName,
        });
        setTimeout(() => dispatch({ type: SCROLL_TO_FIELD, formName: formName, fieldName: null }), 1000);
        return Promise.resolve();
    };
};

export const setFieldError = (formName, fieldName, error) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: SET_FIELD_ERROR,
                formName: formName,
                fieldName: getClearFieldName(fieldName),
                error: error,
            }),
        );
    };
};

export const removeFieldError = (formName, fieldName) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: REMOVE_FIELD_ERROR,
                formName: formName,
                fieldName: getClearFieldName(fieldName),
            }),
        );
    };
};

export const updateFormProperties = (formName, action, isValidate = true) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_FORM_PROPERTY,
                formName: formName,
                action: action,
                isValidate: isValidate,
            }),
        );
    };
};

export const changeFormField = (formName, field) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: CHANGE_FIELD,
                formName: formName,
                field: field,
            }),
        );
    };
};

export const changeFormFieldValue = (formName, value, fieldName) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: CHANGE_FIELD_VALUE,
                formName: formName,
                value: value,
                fieldName: getClearFieldName(fieldName),
            }),
        );
    };
};

export const deleteForm = (formName) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: DELETE_FORM,
                formName: formName,
            }),
        );
    };
};

export const setNewForm = (formName, fields = {}, action = '', visibleFields = null) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: SET_NEW_FORM,
                formName: formName,
                fields: fields,
                action: action,
                visibleFields: visibleFields,
            }),
        );
    };
};

export const updateFields = (formName, fields = {}) => {
    let newfields = {};
    if (Array.isArray(fields)) {
        fields.forEach((f) => {
            newfields[f.name] = f;
        });
    } else {
        newfields = fields;
    }
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_FIELDS,
                formName: formName,
                fields: newfields,
            }),
        );
    };
};

export const updateFieldValues = (formName, fields = {}) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_FIELD_VALUES,
                formName: formName,
                fields: fields,
            }),
        );
    };
};

export const setNewFields = (formName, fields = {}) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: SET_NEW_FIELDS,
                formName: formName,
                fields: fields,
            }),
        );
    };
};

export const replaceFields = (formName, fields = {}) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: REPLACE_FORM_FIELDS,
                formName: formName,
                fields: fields,
            }),
        );
    };
};

export const addNewFields = (formName, fields = {}) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: ADD_NEW_FIELDS,
                formName: formName,
                fields: fields,
            }),
        );
    };
};

export const removeFields = (formName, fieldNames = []) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: REMOVE_FIELD,
                formName: formName,
                fieldNames: fieldNames,
            }),
        );
    };
};

export const changePaymentMethod = (formName, value, paymentMethod) => {
    return (dispatch) => {
        dispatch(changeFormFieldValue(formName, getExtra(value, 'type') === EXTERNAL ? null : value, SOURCE));
        dispatch(changeFormFieldValue(formName, value, SOURCE_CODE_FROM));
        dispatch(changeFormFieldValue(formName, paymentMethod, PAYMENT_METHOD));
        return Promise.resolve();
    };
};

export const changeDeliveryMethod = (formName, deliveryMethod) => {
    return (dispatch) => {
        dispatch(changeFormFieldValue(formName, deliveryMethod, DELIVERY_METHOD));
        return Promise.resolve();
    };
};

export const changeFieldProperty = (formName, fieldName, property, newValue) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: CHANGE_FIELD_PROPERTY,
                formName: formName,
                fieldName: getClearFieldName(fieldName),
                property,
                newValue,
            }),
        );
    };
};
